import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 40px;
    color: #000;

    &:hover:not(.active) {
        background: #f5f5f5;
    }

    &.active {
        background: #246eff;
        color: #fff;
        cursor: default;
    }
`;

const ViewToggleButton = ({ Icon, active = false, onClick }) => {
    const [hover, setHover] = useState(false);

    return (
        <Button
            type="button"
            className={classnames({ active })}
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Icon active={active || hover} />
        </Button>
    );
};

ViewToggleButton.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ViewToggleButton;
